function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreadLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "115.76 151.75 210.55 151.75 191.76 144.19 134.55 144.19 115.76 151.75",
    style: {
      fill: "#E0AB52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "bread",
    points: "115.76 151.75 210.55 151.75 191.76 144.19 134.55 144.19 115.76 151.75",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.69 151.75 191.57 146.07 134.73 146.07 120.62 151.75 205.69 151.75",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.64 154.03 208.67 154.03 210.55 151.75 115.76 151.75 117.64 154.03",
    style: {
      fill: "#E0AB52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.15,149.86c-7.34,0-20.25.94-24.56-1.27s2.84-21.23,24.56-21.23,28.88,19,24.57,21.23S170.5,149.86,163.15,149.86Z",
    style: {
      fill: "#E0AB52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,141.83c-3.28-2-3.87-9-8.66-13.41a26.2,26.2,0,0,1,8.35,3.78C182.57,137.05,183.31,143.77,180.18,141.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.15,127.36a33.29,33.29,0,0,1,3.52.18c2.46,11-2.06,14.23-3.52,14.23s-6-3.26-3.51-14.23A33.1,33.1,0,0,1,163.15,127.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.43,132.2a26.71,26.71,0,0,1,8.36-3.79c-4.79,4.39-5.38,11.39-8.66,13.42C143,143.77,143.74,137.05,146.43,132.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "smoke1",
    d: "M162.49,119.53a32.76,32.76,0,0,0-1.22-8,54.79,54.79,0,0,0-3.07-7.19,25.06,25.06,0,0,1-2.52-8.49,14.82,14.82,0,0,1,1.93-8.67,41.75,41.75,0,0,0,1.68,8,72.48,72.48,0,0,0,3.15,7.23,23.21,23.21,0,0,1,2.45,8.56A13.87,13.87,0,0,1,162.49,119.53Z",
    style: {
      fill: "#E0AB52",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "smoke2",
    d: "M172.86,124.91a19,19,0,0,0-.74-4.7,32.67,32.67,0,0,0-1.81-4.24,14.7,14.7,0,0,1-1.48-5,8.67,8.67,0,0,1,1.16-5.12,24.91,24.91,0,0,0,1,4.7,44.75,44.75,0,0,0,1.86,4.25,13.66,13.66,0,0,1,1.43,5A8.14,8.14,0,0,1,172.86,124.91Z",
    style: {
      fill: "#E0AB52",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "smoke3",
    d: "M154.29,121.42a19.54,19.54,0,0,0-.73-4.7,32.57,32.57,0,0,0-1.81-4.23,14.47,14.47,0,0,1-1.48-5,8.71,8.71,0,0,1,1.15-5.11,24.63,24.63,0,0,0,1,4.69,43.8,43.8,0,0,0,1.86,4.26,13.43,13.43,0,0,1,1.44,5.05A8.05,8.05,0,0,1,154.29,121.42Z",
    style: {
      fill: "#E0AB52",
      opacity: 0.30000000000000004
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadLoader);
export default __webpack_public_path__ + "static/media/BreadLoader.5d5b6e484bb406b78f38a1dcf122d0ca.svg";
export { ForwardRef as ReactComponent };